//Staging URL
const url = "https://backend.embryva.com/"
// const url = "https://zany-space-enigma-r44xvr77j969hx5g9-5000.app.github.dev/"
const ApiConfig = {
  adminLogin: `${url}api/v1/auth/login/`,
  clinicCreate: `${url}api/v1/admin/clinic/create/`,
  createTeam: `${url}api/v1/team/add/`,
  subscriptionNOte: `${url}api/v1/subscription/add-note/`,
  mettingCom: `${url}api/v1/admin/meetings/`,
  listTeam: `${url}api/v1/team/`,
  deleteTeam: `${url}api/v1/team/delete/`,
  updateTeam: `${url}api/v1/team/update/`,
  clinicList: `${url}api/v1/admin/users/clinics/`,
  userSubscription: `${url}api/v1/admin/subscription/plans/`,
  clinicDelete: `${url}api/v1/admin/clinic`,
  parentDelete: `${url}api/v1/admin/parent`,
  userList: `${url}api/v1/admin/users/parents/`,
  adminSubscriptionCreate: `${url}api/v1/admin/subscription/plans/`,
  subscriptionsList: `${url}api/v1/admin/subscription/plans/`,
  subscriptionsListUpdate: `${url}api/v1/admin/subscription/plans/`,
  subscriptionsListDelete: `${url}api/v1/admin/subscription/plans/`,
  subscriptionPlans: `${url}api/v1/admin/subscription/plans/`,
  subscriptionTransactions: `${url}api/v1/admin/subscription/subscriptions/`,
  userButSubscription: `${url}api/v1/payments/create-checkout-session/`,
  transactionList: `${url}api/v1/parent/transactions/`,

  blogList: `${url}api/v1/admin/blogs/`,
  blogCreate: `${url}api/v1/admin/blogs/`,
  blogPublish: `${url}api/v1/admin/blogs/`,
  blogFeature: `${url}api/v1/admin/blogs/`,
  publicBlogList: `${url}api/v1/blogs/`,
  appointmentList: `${url}api/v1/admin/appointments/`,
  subAdminCreate: `${url}api/v1/admin/subadmin/create/`,
  subAdminList: `${url}api/v1/admin/users/subadmins/`,
  adminDashboard: `${url}api/v1/admin/dashboard/stats/`,
  clinicDashboard: `${url}api/v1/donors/statistics/`,
  getAdminProfile: `${url}api/v1/auth/profile/`,
  clinicLogin: `${url}api/v1/auth/login/`,
  forgotPassword: `${url}api/v1/auth/forgot-password/`,
  otpVerify: `${url}api/v1/auth/verify-otp/`,
  adminProfile: `${url}api/v1/admin/profile/update/`,
  uploadImage: `${url}api/v1/admin/profile/image/`,
  adminPasswordChange: `${url}api/v1/auth/reset-password/`,
  createAppoinment: `${url}api/v1/appointments/create/`,
  detailsAppoinment: `${url}api/v1/admin/appointments/`,
  deleteSubadmin: `${url}api/v1/admin/subadmin/`,
  viewClinic: `${url}api/v1/admin/clinic/`,
  donorImport: `${url}api/v1/donors/import/`,
  donorList: `${url}api/v1/donors/`,
  donorDelete: `${url}api/v1/clinic/donors/`,
  donorEdit: `${url}api/v1/admin/clinic/`,
  donorView: `${url}api/v1/donors/`,

  dashboardCount: `${url}api/v1/user/admin/dashboardCount`,
  resendOTP: `${url}api/v1/user/resendOTP`,
  notificationSend: `${url}api/v1/notification/admin/send`,
  getProfile: `${url}api/v1/user/getProfile`,
  verifyOTP: `${url}api/v1/user/verifyOTP`,
  changePassword: `${url}api/v1/user/changePassword`,
  chatMessageList: `${url}api/v1/chatMessage/admin/room/list`,
  chatMessageAdmin: `${url}api/v1/chatMessage/admin/list`,
  classListing: `${url}api/v1/class/admin/list`,
  addClass: `${url}api/v1/class/admin/create`,
  deleteClass: `${url}api/v1/class/admin/delete`,

  holidayList: `${url}api/v1/holiday/admin/list`,
  holidayAdd: `${url}api/v1/holiday/admin/create`,
  holidayDelete: `${url}api/v1/holiday/admin/delete`,
  bannerList: `${url}api/v1/banner/admin/list`,
  bannerCreate: `${url}api/v1/banner/admin/create`,
  bannerDelete: `${url}api/v1/banner/admin/delete`,
  uploadImage: `${url}api/v1/user/uploadFile`,
  planList: `${url}api/v1/plan/admin/list`,
  updateStatus: `${url}api/v1/user/admin/updateStatus`,
  planCreate: `${url}api/v1/plan/admin/create`,
  planUpdate: `${url}api/v1/plan/admin/update`,
  planDelete: `${url}api/v1/plan/admin/delete`,
  purchaseSubs: `${url}api/v1/plan/admin/purchase/list`,
  coachList: `${url}api/v1/coach/admin/list`,
  coachAdd: `${url}api/v1/coach/admin/create`,
  tutorialList: `${url}api/v1/tutorial/admin/list`,
  tutorialdelete: `${url}api/v1/tutorial/admin/delete`,
  tutorialContentdelete: `${url}api/v1/tutorial/content/admin/delete`,
  tutorialcreate: `${url}api/v1/tutorial/admin/create`,
  tutorialView: `${url}api/v1/tutorial/admin/view`,
  tutorialcontentAdd: `${url}api/v1/tutorial/content/admin/create`,
  tutorialcontentList: `${url}api/v1/tutorial/content/admin/list`,
  coachDelete: `${url}api/v1/coach/admin/delete`,
  slotListing: `${url}api/v1/slot/admin/list`,
  addSlot: `${url}api/v1/slot/admin/create`,
  addDelete: `${url}api/v1/slot/admin/delete`,
  listRoundContent: `${url}api/v1/tutorial/content/round/admin/list`,
  addRoundContent: `${url}api/v1/tutorial/content/round/admin/create`,
  deleteRoundContent: `${url}api/v1/tutorial/content/round/admin/delete`,
  listStaticContent: `${url}api/v1/staticContent/admin/list`,
  updateStaticContent: `${url}api/v1/staticContent/admin/update`,
  createStaticContent: `${url}api/v1/staticContent/admin/create`,
  deleteStaticContent: `${url}api/v1/staticContent/admin/delete`,
  promoListing: `${url}api/v1/plan/admin/promo/list`,
  addPromoCode: `${url}api/v1/plan/admin/promo/create`,
  deletePromoCode: `${url}api/v1/plan/admin/promo/delete`,
  upgradePlan: `${url}api/v1/plan/admin/purchase/create`,
  updateSubAdminPermissions: `${url}api/v1/subadmin/`,
  createInstantMeeting: `${url}api/v1/admin/meetings/create-instant/`,
    doxyMeRoomUrl: "Https://doxy.me/embryva",
  meetingList: `${url}api/v1/admin/meetings/`,
  meetingDelete: `${url}api/v1/admin/meetings/delete/`,
  meetingUpdate: `${url}api/v1/admin/meetings/`,
  meetingDetails: `${url}api/v1/admin/meetings/`,
  meetingStatusUpdate: `${url}api/v1/admin/meetings/`,
  clinicMeeting: `${url}api/v1/clinic/meetings/`,
  clinicAppointment: `${url}api/v1/clinic/appointments/`,
  responseData: `${url}api/v1/clinic-api-configs/`,
  responseList: `${url}api/v1/clinic-api-configs/`,
  responseDelete: `${url}api/v1/clinic-api-configs/`,

};
export default ApiConfig;
